import React from 'react';
import { motion } from 'framer-motion';

const days = [
    {
        d: 'Día 01',
        title: 'Aterrizaje & Calibración',
        items: ['Llegada a Madrid', 'Sesión de bienvenida', 'Recorrido del terreno IFEMA', 'Cena de bienvenida'],
    },
    {
        d: 'Día 02',
        title: 'Despliegue Comercial',
        items: ['Agenda B2B intensiva', 'Networking de alto nivel', 'Reuniones estratégicas', 'Revisión diaria con la Tribu'],
    },
    {
        d: 'Día 03',
        title: 'Exploración Técnica',
        items: ['Agenda comercial continuada', 'Visitas guiadas a proyectos', 'Pabellón de innovación', 'Mapping IA'],
    },
    {
        d: 'Día 04',
        title: 'Inmersión & Vínculo',
        items: ['Barrio de las Letras', 'Tapas tradicionales', 'Show flamenco', 'Cierre relacional'],
    },
    {
        d: 'Día 05',
        title: 'Retorno Estratégico',
        items: ['Portafolio de oportunidades', 'Despedida de la Tribu', 'Roadmap post-feria activado'],
    },
];

const Itinerary = () => (
    <section id="itinerario" className="relative py-16 md:py-24 border-t border-white/10 overflow-hidden bg-[color:var(--surface)]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
            <div className="mb-10 max-w-3xl">
                <div className="overline mb-6">Itinerario táctico</div>
                <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-[-0.02em]">
                    Un viaje diseñado <span className="italic-accent text-[color:var(--brand)] font-normal">para resultados.</span>
                </h2>
            </div>

            <div className="relative">
                {/* horizontal timeline line */}
                <div className="absolute left-0 right-0 top-6 hidden md:block h-px bg-white/15" />
                <div className="grid grid-cols-1 md:grid-cols-5 gap-6 md:gap-4">
                    {days.map((day, i) => (
                        <motion.div
                            key={day.d}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: '-60px' }}
                            transition={{ duration: 0.7, delay: i * 0.08 }}
                            className="relative pt-14"
                        >
                            <span className="absolute top-4 left-0 h-4 w-4 rounded-full border border-white/40 bg-[color:var(--bg)]">
                                <span className="absolute inset-1 rounded-full bg-[color:var(--magenta)]" />
                            </span>
                            <div className="overline text-white/50 mb-3">{day.d}</div>
                            <div className="font-display text-2xl text-white leading-tight mb-4">
                                {day.title}
                            </div>
                            <ul className="space-y-2">
                                {day.items.map((it, k) => (
                                    <li key={k} className="text-sm text-white/60 leading-relaxed">
                                        {it}
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default Itinerary;
